<template>
  <div id="app">
    <cHeader></cHeader>
    <cMenu></cMenu>
    <router-view/>
  </div>
</template>

<script>
import cHeader from './components/cHeader'
import cMenu from './components/cMenu'
export default {
  name: 'App',
  components: {
    cHeader: cHeader,
    cMenu: cMenu
  },
  data () {
    return {
      msg: '卧式销量检测柜'
    }
  }
}
</script>

<style lang="scss">
  html,body{
    margin: 0;
    /* background: rgb(74, 81, 87); */
    min-height: 100%;
    background-size: cover;
    background-image: url("../static/a.jpg");
    color: #fff;
  }
  .fl {
    float: left;
  }
  .fr {
    float: right;
  }
  .clear:after{display:block;clear:both;content:"";visibility:hidden;height:0}
  .clear{zoom:1}
  .wraper {
    box-sizing: border-box;
    margin-left: 200px;
    padding: 20px;
    /* background: rgba(0,0,0,0.25); */
    min-height: calc(100vh - 45px);
  }
  .export_btn {
    width:80px;
    float:right;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue